<template>
    <div>
        <div class="card">
          <div class="card-body">
            <div class="row">
            <div class="col">
              <h5>{{fecha|fecha}}</h5>
              <date-picker
                                  v-model="fecha"
                                  :range="false"
                                  format="DD-MM-YYYY"
                                  :editable="false"
                                  :clearable="true"
                                  value-type="YYYY-MM-DD"
                                  @change="refrescar"
                                ></date-picker>
            </div>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div
                  class="card-header background-blue-3"
                  id="headingOne"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                <h3 class="mb-0">TARIFAS TRANSBORDADOR</h3>

                </div>
                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                <!-- <div class="table-responsive">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th><h4>Naviera</h4></th>
                <th><h4>Carroceria</h4></th>
                <th><h4>Vigente Desde</h4></th>
                <th><h4>Valor (CLP)</h4></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="t in tarifas_transbordadores" :key="t.id">
                <td class="table-user">
                  {{t.empresa}}
                </td>
                <td>{{t.carroceria}}</td>
                <td>{{t.vigente_desde|fecha}}</td>
                <td>{{t.valor|formatear_miles}}</td>
                
              </tr>
            </tbody>
          </table>
        </div> -->
        <div class="table-responsive" v-for="item in tarifas_transbordadores">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th colspan="100"><h4>{{item.nombre}}</h4></th>
                
              </tr>
              <!-- <tr>
                <th><h4>Carroceria</h4></th>
                <th><h4>Vigente Desde</h4></th>
                <th><h4>Valor (CLP)</h4></th>
              </tr> -->
            </thead>
            <tbody>
              <tr v-for="t in item.tarifas" :key="t.id">
                <td>{{t.carroceria}}</td>
                <td>{{t.vigente_desde|fecha}}</td>
                <td>{{t.valor|formatear_miles}}</td>
                
              </tr>
            </tbody>
          </table>
        </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="accordion" id="peajes">
              <div class="card">
                <div
                  class="card-header background-blue-3"
                  id="headingOne"
                  data-toggle="collapse"
                  data-target="#peajesOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                <h3 class="mb-0">TARIFAS PEAJES</h3>

                </div>
                <div
                  id="peajesOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#peajes"
                >
                <!-- <div class="table-responsive" v-for="item in tarifas_peajes" :key="item.id">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th colspan="100"><h4>{{item.nombre}}</h4></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in item.peajes">
                <th>{{p.nombre}}</th>
                <td v-for="t in p.tarifas">{{t.tipo_vehiculo}} - {{t.valor | formatear_miles}}</td>
              </tr>
            </tbody>
          </table>
        </div> -->

          <div v-for="item in tarifas_peajes">
            <div class="title">
              <h4>{{item.nombre}}</h4>
            </div>
            <div class="table-max">
              <div class="table-responsive" v-for="p in item.peajes" :key="item.id">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th colspan="100"><h4>{{p.nombre}}</h4></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="t in p.tarifas">
                <td>{{t.tipo_vehiculo}}</td>
                <td>{{t.vigente_desde | fecha}}</td>
                <td>{{t.valor | formatear_miles}}</td>
              </tr>
            </tbody>
          </table>
        </div>
            </div>
          </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fecha:new Date().toISOString().split('T')[0],
        tarifas_transbordadores:[],
        tarifas_peajes:[]
    }),
    mounted() {
        this.tarifa_transbordador()
    },
    methods:{
        refrescar(){
          this.tarifa_transbordador()
          this.tarifa_peajes()
        },
        async tarifa_transbordador(){
            await this.axios.get(`${this.api}/tarifa_transbordador/fecha/${this.fecha}`,this.cabeceras_json).then((res)=>{
                this.tarifas_transbordadores = res.data.data
            }).catch((e)=>{
                //alert(e);
            })
            this.tarifa_peajes()
        },

        async tarifa_peajes(){
          await this.axios.get(`${this.api}/tarifa_peaje/fecha/${this.fecha}`,this.cabeceras_json).then((res)=>{
                this.tarifas_peajes = res.data.data
            }).catch((e)=>{
                //alert(e);
            })
        }
    },
    computed:{
        //...mapState(['api','cabeceras_json','autenticado','usuario','token'])
        ...mapState({
          autenticado:state => state.autenticado,
          token:state => state.token,
          api:state => state.api,
          cabeceras_json:state => state.cabeceras_json,
          menus:state => state.menus,
        })
    }
}
</script>
<style>
.title{
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: rgb(121, 234, 164);
  padding: 0.5em;
}

.table-max{
  max-height: 400px;
  overflow: auto;
}
</style>